import storage from 'store';

export const setIsAuthed = (isAuthed: boolean) => {
  storage.set('isAuthed', isAuthed);
};

export const getIsAuthed = () => {
  return storage.get('isAuthed');
};
